<div class="row">
    <div class="col-md-12">
        <div class="card card-accent-success">
            <div class="card-header-buscador">
                <i class="fa fa-align-justify"></i> {{ titleList }}
            </div>

            <!-- Porcentaje Total -->
            <div class="mb-2">
                <strong>Porcentaje Total: {{ getPorcentajeTotal() | number:'1.2-2':'es-ES' }}%</strong>
                <div *ngIf="!isPorcentajeTotalValido()" class="text-danger">
                    El porcentaje total debe ser exactamente 100%.
                </div>
            </div>

            <div class="card-body-grid">
                <p-table #tableSearch
                         [value]="result"
                         [columns]="cols"
                         sortField="Descripcion"
                         [loading]="loading"
                         [paginator]="false"
                         [lazy]="false"
                         styleClass="table table-responsive-sm table-striped table-sm"
                         [ngClass]="displayGridHidden(result)"
                         editable="true">

                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                {{col.header}}
                                <p-sortIcon *ngIf="col.field !== 'Link'" [field]="col.field"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                        <tr>
                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                <ng-container [ngSwitch]="col.field">
                                    <!-- PorcentajeSemanal editable -->
                                    <ng-container *ngSwitchCase="'PorcentajeSemanal'">
                                        <input type="number"
                                               [(ngModel)]="rowData[col.field]"
                                               [disabled]="saving"
                                               (ngModelChange)="onAnyFieldChanged()"
                                               (blur)="formatPorcentaje(rowData, col.field)"
                                               min="0" max="100" step="0.01"
                                               required
                                               name="porcentajeSemanal{{rowIndex}}"
                                               style="width: 80px;"
                                               #porcentajeInput="ngModel" />
                                        <div *ngIf="porcentajeInput.invalid && porcentajeInput.touched" class="text-danger">
                                            Este campo debe tener un valor entre 0 y 100
                                        </div>
                                    </ng-container>
                                    <!-- NumeroInspectores editable --> <!--TODO: agoldero comentado hasta que lo soliciten-->
                                    <!--<ng-container *ngSwitchCase="'NumeroInspectores'">
        <input type="number"
               [(ngModel)]="rowData[col.field]"
               (ngModelChange)="onAnyFieldChanged()"
               min="0"
               step="1"
               required
               name="numeroInspectores{{rowIndex}}"
               style="width: 80px;"
               #inspectoresInput="ngModel" />
        <div *ngIf="inspectoresInput.invalid && inspectoresInput.touched" class="text-danger">
            Este campo es obligatorio.
        </div>
    </ng-container>-->
                                    <ng-container *ngSwitchCase="'FinesDeSemana'">
                                        <p-toggleButton class="form-control-togglebutton"
                                                        [disabled]="saving"
                                                        [ngModel]="rowData.FinesDeSemana"
                                                       (onChange)="handleFinesDeSemanaChange($event, rowIndex)"
                                                        onLabel="Sí" offLabel="NO"
                                                        onIcon="pi pi-check" offIcon="pi pi-times"
                                                        [name]="'finesDeSemana' + rowIndex">
                                        </p-toggleButton>
                                    </ng-container>


                                    <!-- Otros campos solo lectura -->
                                    <ng-container *ngSwitchDefault>
                                        <span *ngIf="col.field !== 'Link' && col.field !== 'Activo'">
                                            {{rowData[col.field]}}
                                        </span>
                                    </ng-container>
                                </ng-container>
                            </td>

                        </tr>
                    </ng-template>

                </p-table>
                <div class="p-2" *ngIf="tableSearch.totalRecords">Se han encontrado {{ tableSearch.totalRecords  | number:'1.0-0':'es-ES' }} registros</div>
                <div class="empty-grid" *ngIf="tableSearch.totalRecords === 0">No se ha encontrado ningún registro</div>
            </div>
        </div>
    </div>
</div>
